import MoveContent from './MoveContent';
export default MoveContent;
